<template>
    <div>
        <v-dialog
            v-model="advancedFilter"
            max-width="400"
        >
            <v-card>
                <w-toolbar color="teal" title="Filtre Avancé"/>
                <v-card-text>
                    <v-container fluid>
                        <str-worker-filter-fieldset :filter="filter"/>
                    </v-container>
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                    <v-spacer/>
                    <w-btn-close @press="advancedFilter = false"/>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-card flat>
            <v-card-text>
                <v-row dense>
                    <v-col cols="6">
                        <v-row dense>
                            <v-col cols="12">
                                <w-fieldset title="Opération">
                                    <slot></slot>
                                </w-fieldset>
                            </v-col>
                            <v-col cols="12">
                                <v-alert
                                    class="ma-1"
                                    text
                                    dense
                                    color="teal"
                                    icon="mdi-clock-fast"
                                    border="left"
                                    v-if="selected.length === 0"
                                >
                                    {{ $t("common.worker_select_description") }}
                                </v-alert>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="6">
                        <w-fieldset
                            :title="`${$t('module.workers')} ${total}`"
                            show-add-action
                            icon="mdi-filter"
                            @add="advancedFilter = true"
                        >
                            <w-data-table
                                v-model="selected"
                                show-select
                                :headers="headers"
                                :items="workers"
                                :loading="loading"
                                disable-pagination
                                fixed-header
                                height="400"
                            >
                                <template v-slot:[`item.code`]="{ item }">
                                    <w-chip :text="item.code"/>
                                </template>
                                <template v-slot:[`item.name`]="{ item }">
                                    <w-inline-text bold :text="item.name"/>
                                </template>
                            </w-data-table>
                        </w-fieldset>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>

        <input type="hidden"/>
    </div>
</template>

<script>
import StrWorkerFilterFieldset from "./StrWorkerFilterFieldset.vue";
import axios from "axios";
import useSharedData from "@/use/SharedData";
import {onMounted, ref, watch} from "vue";
import useSharedMethod from "@/use/SharedMethod";
import useTools from "@/use/Tools";

export default {
    components: {StrWorkerFilterFieldset},
    props: {
        value: {
            type: Object,
            required: true,
            default: () => {
                return {
                    workers: [],
                    filter: {},
                };
            },
        },
        action: String,
    },
    emits: ["input"],
    setup(props, {emit}) {
        const {transformFilterValues} = useSharedMethod();
        const {$i18n} = useTools();
        const {dialog, loading, total, itemsPerPage} = useSharedData();
        const advancedFilter = ref(false);
        const filter = ref({phase: "ACTIVE", action: props.action});
        const selected = ref([]);
        const workers = ref([]);

        const headers = [
            {
                text: $i18n.t("common.code"),
                align: "start",
                sortable: true,
                value: "code",
            },
            {
                text: $i18n.t("common.lastname"),
                align: "start",
                sortable: true,
                value: "name",
            },
            {
                text: "",
                align: "start",
                sortable: false,
                value: "kind",
            },
        ];

        function findAll() {
            loading.value = true;
            filter.value.allRecords = true;
            axios.get(`/workers/simpleFindAll`, {
                params: transformFilterValues(filter.value),
            }).then((response) => {
                workers.value = response.data;
                total.value = response.data.length;
            }).finally(() => {
                loading.value = false;
            });
        }

        watch(() => filter.value, () => {
            emit("input", {
                workers: selected.value,
                filter: filter.value,
            });
            findAll();
        }, {deep: true});

        onMounted(() => findAll());

        return {
            dialog,
            loading,
            total,
            itemsPerPage,
            advancedFilter,
            filter,
            selected,
            workers,
            headers,
        }
    }
};
</script>
